// A client pipeline in small, for its tile in All boards: its stage columns with a bar for each deal, in the
// board's own tile colors.

import { columnOf, dealsOf, stagesOf } from "../../../shared/pipeline";
import type { Board, Entry } from "../../../shared/types";
import { stageColor } from "./bits";
import "../../styles/pipeline.css";

export function PipelineThumb({ entries }: { board: Board; entries: Entry[] }) {
  const { data } = stagesOf(entries);
  const deals = dealsOf(entries);
  return (
    <div className="ov-pp">
      <div className="ov-pp-board">
        {data.stages.slice(0, 6).map((s, i) => {
          const col = columnOf(deals, s, data.stages);
          return (
            <div key={s.id} className="ov-pp-col">
              <b>{s.name}</b>
              <i style={{ background: stageColor(i, s.won) }} />
              {col.slice(0, 6).map((d) => (
                <span key={d.id} />
              ))}
            </div>
          );
        })}
      </div>
      {/* the shelf beside it, where its widgets sit */}
      <div className="ov-pp-shelf">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}
